<template>
  <div class="border">
    <h4>{{ title }}</h4>
    <list
      title_add="Добавить цену"
      title_add_key="add_price"
      :filters="filters"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="link === 'prices' ? false : true"
      :isAdd="link === 'prices' ? false : true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id", "link", "title"],
  created() {
    this.itemLink += `/${this.id}/${this.link}`;
    this.setLink += `/${this.id}/${this.link}`;
  },
  data() {
    return {
      filters: [
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "name",
          field_key: "shop",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "shop",
          label: "Магазин",
          type: "select",
          modal: "shop",
          selectKey: "name",
        },
        {
          col: " col-12 col-md-7",
          key: "price",
          label: "Цена",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-5",
          key: "quantity",
          label: "Количество",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_field",
      itemLink: "variants",
      setLink: "variants",
      columns: [
        {
          key: "shop",
          object: "name",
          title: "Магазин",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price",
          title: "Цена",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "quantity",
          title: "Количество",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "reason",
          title: "Причина",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        // {
        //   key: "user",
        //   title: "Отвественный",
        //   object: "name",
        //   checkbox: false,
        //   disableLink: true,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },
        // {
        //   key: "order",
        //   title: "Заказ",
        //   disableLink: false,
        //   object: "id",
        //   checkbox: false,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },
        {
          key: "created_at",
          title: "",
          dateTimeFormat: true,
          control: false,
          align: "right",
          timer: false,
          detail: false,
        },
        // {
        //   // detail: true,
        //   remove: true,
        // },
      ],
    };
  },
};
</script>
<style>
</style>
